import React from 'react';

import { convertStringToValidHtml } from '../../../utilities/lister-utilities';

const InsecureBanner = ({ banner, testId, classes }) => (
	<div
		className={classes}
		// eslint-disable-next-line react/no-danger
		dangerouslySetInnerHTML={{
			__html: convertStringToValidHtml(banner),
		}}
		data-testid={testId}
		data-tag-name="top-banner"
	/>
);

export default InsecureBanner;
